import React from 'react';
import { createUseStyles } from 'react-jss';

import './ChatBot.css';


function formatText(text) {
  // Sostituisce i punti seguiti da uno spazio con un punto e due linee nuove (crea paragrafi)
  if(!text) return text
  
  text = text.replace(/\. /g, '.<br><br>');
  
  // Aggiunge un nuovo paragrafo dopo ogni frase che termina con punto esclamativo o interrogativo
  text = text.replace(/([!?]) /g, '$1<br><br>');
  
  return text;
}

// Componente React per renderizzare il testo formattato
const FormattedText = ({ text }) => {
  const formattedText = formatText(text);

  return (
    <div dangerouslySetInnerHTML={{ __html: formattedText }} />
  );
};

function BotMessage({msg, isLastBotMessage}) {
const st=styles();
  return (
          <div
            key={msg.id}
            className={'bot flex flex-row align-items-end mb-1  '+st.container }
          >
          
            <div className="message-text  align-self-start ml-3">
              
              <FormattedText text={msg.testo} />
            </div>

          </div>
  );
}

const styles = createUseStyles({
  container: {
    width:"100%"
  }
});

export default BotMessage;